// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const staraptor: PokeData = {
  "id": 398,
  "name": "staraptor",
  "height": 12,
  "weight": 249,
  "base_experience": 218,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "wing-attack",
    "whirlwind",
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "agility",
    "quick-attack",
    "double-team",
    "endeavor",
    "aerial-ace",
    "roost",
    "close-combat",
    "air-slash",
    "brave-bird",
    "giga-impact",
    "final-gambit"
  ],
  "moves": [
    "gust",
    "tackle",
    "growl",
    "quick-attack",
    "aerial-ace",
    "roost",
    "close-combat",
    "air-slash",
    "brave-bird",
    "headbutt",
    "chatter",
    "scary-face",
    "protect"
  ],
  "evolution_chain": {
    "id": 206,
    "item": null,
    "species": [
      {
        "name": "starly",
        "order": 426,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "staravia",
        "order": 427,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 396,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "staraptor",
        "order": 428,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 397,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 136,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
